export default {
    description: "Description"
}